<template>
  <div id="app" style="height: 100vh">
    <router-view />
  </div>
</template>

<script>
export default {
}
</script>
